<template lang="pug">
    div
        .modal-header
            slot(name='header')
                h3 Commands available
        .modal-body
            slot(name='body')
                p Shift + Click = Toggle map complete*
                p Alt + Click = Toggle map shaped
                p Ctrl(Command on Mac) + Click = Alternate permanent sextant
                p
                    i *Making a map in-complete will block it from having sextants.
                h4 Search commands
                p Tier: X = finds all maps of this tier
                p complete:X = Press enter to complete all the maps in this tier
                p uncomplete:X = Press enter to uncomplete all the maps in this tier
                br
                p To search for a map just type the name(even without spaces). You can then press enter to center on it.

        .modal-footer
            slot(name='header')
                button.modal-default-button(@click="$emit('close_modal')") Close
</template>

<script>
    export default {
        name: "commands-help"
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/modals/CommandsHelp.vue